<template>
  <div class="card-top" v-show="show">
    <!-- 限时秒杀 -->
    <div class="card-huodong" v-for="(v1, i1) in actList"
         :key="i1"
         v-if="v1.goodsList.length">
      <template v-if="!v1.hide">
        <div class="card1">
          <image class="xianshimiaosha" :src="v1.img1" mode="aspectFit"></image>
          <div style="width: 120rpx;margin: 0 auto;">
            <countDown v-if="v1.actType == 5" :startTime="v1.dataTime" :id="i1"></countDown>
          </div>
          <div v-if="v1.actType != 5" style="color: #999494;font-size: 0.9em;">人多价更低</div>
          <image class="zhong" :src="v1.img2" mode="aspectFit"></image>
        </div>
        <image
            class="huodong-line"
            src="https://img2.coocaa.com/ui/partner-mini-program/huodong-line.png"
            mode="aspectFit"
        ></image>
        <template v-if="v1.goodsList">
          <div class="right-goods-list">
            <div class="card2" v-for="(v2, i2) in v1.goodsList" :key="i2" @click="clickActGood(v2)">
              <!-- 商品 -->
              <image
                  class="shangpin"
                  :src="v2.ecsGoodsDto.goodsImg"
                  mode="widthFix"
              ></image>
              <div class="act-goods-info">
                <div class="div11">
                  <span>¥</span>
                  <span>{{ v2.ecsGoodsDto.shopPrice }}</span>
                </div>
                <div class="div22" v-if="v1.actType == 5">
                  <image
                      class="zhijiang"
                      src="https://img2.coocaa.com/ui/partner-mini-program/zhijiang.png"
                      mode="aspectFit"
                  ></image>
                  <div style="font-size: 0.9em;">
                    直降¥{{
                      v2.ecsGoodsDto.marketPrice - v2.ecsGoodsDto.shopPrice
                    }}
                  </div>
                </div>
                <div class="div22" v-if="v1.actType == 6">
                  <image
                      class="zhijiang"
                      src="https://img2.coocaa.com/ui/partner-mini-program/tuan.png"
                      mode="aspectFit"
                  ></image>
                  <div style="font-size: 0.9em;">{{ v1.actPromotionGroupBuy.groupNum }}人团</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="gengduo" @click="clickGengDuo(v1.actType)">
          更多
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import countDown from './countDown.vue'
export default {
  name: "index",
  components: {
    countDown
  },
  props: {
    isIOS: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      actList: [
      ]
    }
  },
  created() {
    this.getHomePageActPreview()
  },
  mounted() {
  },
  methods: {
    clickGengDuo (actType) {
      this.$constants.router(`/pages/index/activeList?actType=${actType}`)
    },
    clickActGood (v2) {
      this.$emit('btnClickLog', {
        goodsId: v2.goodsId
      })
    },
    getHomePageActPreview () {
      const isIOS = this.isIOS
      this.$service.homePageActPreview({
        channel: isIOS ? 'ios' : 'android'
      }).then(res => {
        this.actList = []
        this.show = false
        res.forEach(v1 => {
          if (v1.actOpen) {
            // actType 5 秒杀
            // actType 6 拼团
            if (v1.actType == 5) {
              v1.img1 =
                  'https://img2.coocaa.com/ui/partner-mini-program/xianshimiaosha.png'
              v1.img2 =
                  'https://img2.coocaa.com/ui/partner-mini-program/zhong.png'
            } else if (v1.actType == 6) {
              v1.img1 =
                  'https://img2.coocaa.com/ui/partner-mini-program/dijiapintuan.png'
              v1.img2 =
                  'https://img2.coocaa.com/ui/partner-mini-program/shop-bag.png'
            }

            let now = Date.now()
            // 计算距离开始和结束分别多久
            v1.startLastTime = v1.startTime - now
            v1.isStart = v1.startLastTime > 0
            if (v1.startLastTime > 48 * 3600 * 1000) {
              v1.hide = true
            }
            // 测试
            // v1.hide = true
            if (!v1.hide) {
              this.show = true
            }
            v1.endLastTime = (v1.endTime * 1000) - now
            v1.isEnd = v1.endLastTime > 0
            let dataTime = v1.isStart ? v1.startLastTime : v1.endLastTime
            v1.dataTime = dataTime
            // 测试
            // v1.dataTime = 3600000 * 24
            let { actPromotionGoodsDtoList } = v1
            v1.goodsList = actPromotionGoodsDtoList.filter((v2, index) => {
              return (
                  !isIOS || [0, 1].includes(parseInt(v2.ecsGoodsDto.goodsClassify))
              )
            })
            v1.goodsList.splice(2)
            this.actList.push(v1)
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.card-top {
  margin: 32rpx 0;
  .card-huodong {
    padding: 20rpx 28rpx;
    width: 100%;
    margin-bottom: 16rpx;
    background: linear-gradient(180deg, #FFF2F2 0%, #FFFFFF 100%);
    border-radius: 8px;
    display: flex;
    overflow:hidden;
    position: relative;
    box-sizing: border-box;
    .gengduo{
      position: absolute;
      right: 0;
      top:0;
      width:80rpx;
      color:#fff
      text-align: center;
      line-height:40rpx;
      background:#FF4D00;
    }

    .card1 {
      width: 140rpx;
      text-align: center;
    }
    .right-goods-list {
      flex: 1;
      display: flex;
    }
    .card2 + .card2 {
      margin-left: 30rpx;
    }
    .card2 {
      display: flex;
      align-items: center;
      .shangpin {
        width: 112rpx;
        height: 112rpx;
        border-radius: 5px;
        box-shadow: 0px 0px 1px #d8d8d8;
      }
      .act-goods-info {
        margin-left: 8rpx;
        .div11 {
          color: #FC4C00;
        }

        .div22 {
          margin-top:10rpx;
          display: flex;
          align-items: center;
          color: #B09174;
          white-space:nowrap;
          .zhijiang {
            // width: 12px;
            // height: 12px;
            width: 24rpx;
            height: 24rpx;
            margin-right: 4rpx;
          }
        }
      }
    }

    .huodong-line {
      height: 136rpx;
      width: 6rpx;
      margin: 0 16rpx 0 6rpx;
    }

    .xianshimiaosha {
      // width: 56px;
      // height: 14px;
      width: 112rpx;
      height: 28rpx;
    }

    .zhong {
      // width: 32px;
      // height: 32px;
      width: 64rpx;
      height: 64rpx;
    }
  }
}

</style>
